import React, { useEffect, useMemo, useRef, useState } from "react";

export default function ThemeColorPicker(param: any) {
    let [open, setOpen] = useState(false);
    let [textColor, setTextColor] = useState("#111827");
    let [bgColor, setBgColor] = useState("#FFFFFF");
    let [mode, setMode] = useState("text");

    const THEME_BASES = [
        "#000000", "#E7E6E6", "#44546A",
        "#5B9BD5", "#ED7D31", "#A5A5A5",
        "#FFC000", "#4472C4", "#70AD47",
    ];

    const clamp = (n: number) => Math.max(0, Math.min(255, Math.round(n)));

    const hexToRgb = (hex: string) => {
        const h = hex.replace("#", "");
        const n = parseInt(h, 16);

        return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255, };
    };

    const rgbToHex = (r: number, g: number, b: number) => `#${[r, g, b].map((x) => clamp(x).toString(16).padStart(2, "0")).join("")}`.toUpperCase();

    const mix = (a: string, b: string, t: number) => {
        const A = hexToRgb(a);
        const B = hexToRgb(b);

        return rgbToHex(
            A.r + (B.r - A.r) * t,
            A.g + (B.g - A.g) * t,
            A.b + (B.b - A.b) * t
        );
    };

    const buildColumn = (base: string) => {
        const tints = [0.85, 0.68, 0.52, 0.36].map((t) => mix(base, "#FFFFFF", t));
        const shades = [0.3, 0.48, 0.66, 0.82].map((t) => mix(base, "#000000", t));
        return [base, ...tints, ...shades];
    };

    const columns = useMemo(() => THEME_BASES.map((b) => buildColumn(b)), []);

    const selected = mode === "text" ? textColor : bgColor;

    const apply = (hex: string) => {
        if (mode === "text") {
            setTextColor(hex);
        } else {
            setBgColor(hex);
        }

        setOpen(false);
    };

    const handleOpen = (newMode: any) => {
        mode = newMode
        setMode(mode)

        console.log(newMode)
        setOpen(true);
    };

    return (
        <div className="overflowVisible" style={{ borderRadius: "20 !important", }}>
            {/* BUTTONS */}
            <div style={{ borderRadius: "20 !important", background: "#FFFFFF", display: "inline-flex", }} className="box ws-12 height35 width350">
                {/* TEXT BUTTON */}
                <button type="button" onClick={(e) => handleOpen("text")} style={{ padding: "10px 14px", border: "none", color: "#0F172A", }} className="w-20">
                    Text
                </button>

                {param?.text_val && <span className="pb  forceSingleLine text-center w-50" style={{ padding: "8px 8px", color: param?.text_color, background: param?.text_bg }}> {param?.text_val} </span>}
                <div style={{ width: 1, background: "#CBD5E1", }} />

                {/* BACKGROUND BUTTON */}
                <button type="button" onClick={(e) => handleOpen("bg")} style={{ padding: "10px 14px", border: "none", color: "#0F172A", }} className="pull-right w-30">
                    Background
                </button>
            </div>

            {/* POPUP */}
            {open && (
                <div style={{ position: "fixed", background: "#FFFFFF", border: "1px solid #CBD5E1", borderRadius: 20, padding: 18, width: 560, zIndex: 9999, }} className="overflowVisible">
                    {/* HEADER */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, }} >
                        <div style={{ fontSize: 22, fontWeight: 800, color: "#172554", }}>Theme Colors </div>

                        <div style={{ display: "flex", alignItems: "center", gap: 12, }} >
                            <div style={{ fontSize: 14, fontWeight: 600, color: "#475569", }}>
                                Editing:{" "} <span style={{ color: "#0F172A", fontWeight: 800, }}>{mode === "text" ? "Text" : "Background"} </span>
                            </div>

                            <button onClick={() => setOpen(false)} style={{ border: "none", background: "transparent", fontSize: 22, lineHeight: 1, color: "#EF4444", }} >
                                ×
                            </button>
                        </div>
                    </div>

                    {/* MAIN COLORS */}
                    <div style={{ display: "grid", gridTemplateColumns: `repeat(${columns.length}, 44px)`, gap: 14, marginBottom: 12, }} >
                        {columns.map((col, i) => (
                            <button key={i} type="button" onClick={() => apply(col[0])} title={col[0]}
                                style={{
                                    width: 44, height: 44, borderRadius: 10, background: col[0],
                                    border: selected === col[0] ? "3px solid #111827" : "1px solid rgba(15,23,42,0.18)",
                                }}
                            />
                        ))}
                    </div>

                    {/* SHADES */}
                    <div
                        style={{ display: "grid", gridTemplateColumns: `repeat(${columns.length}, 44px)`, gap: 14, }}>
                        {columns.map((col, i) => (
                            <div key={i} style={{ borderRadius: 12, border: "1px solid rgba(15,23,42,0.14)", }}>
                                {col.slice(1)
                                    .map((hex) => (
                                        <div key={hex} onClick={() => apply(hex)}
                                            style={{
                                                height: 30, background: hex, outline: selected === hex ? "2px solid #111827" : "none", outlineOffset: "-2px",
                                            }}
                                        />
                                    ))}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}